import React, { MouseEventHandler } from "react";

import { KeyColorRole } from "../../../styles/colors/types";
import { IconName } from "../../../styles/icons/icons";
import { Icon } from "../../content";
import { Center, styledWithConfig } from "../../layout";
import { IconButtonSize, sizeMap } from "./consts";
import useGetIconButtonStyles from "./hooks/useGetIconButtonStyles";

const ButtonComponent = styledWithConfig("button");

export type IconButtonProps = {
  iconName: IconName;
  onClick: MouseEventHandler;
  accessibilityLabel: string | null;
  disabled?: boolean;
  tone?: KeyColorRole;
  size?: IconButtonSize;
  blend?: boolean;
};

const IconButton = React.forwardRef<any, IconButtonProps>(
  (
    {
      iconName,
      onClick,
      accessibilityLabel,
      size = "large",
      tone = "primary",
      disabled = false,
      blend = false
    },
    ref
  ) => {
    const styleProps = useGetIconButtonStyles({
      tone,
      disabled,
      blend,
      size
    });

    const { iconSize } = sizeMap[size];

    return (
      <ButtonComponent
        padding="none"
        onClick={onClick}
        aria-label={accessibilityLabel ?? undefined}
        disabled={disabled}
        ref={ref}
        {...styleProps}
      >
        <Center>
          <Icon accessibilityLabel={null} iconName={iconName} size={iconSize} />
        </Center>
      </ButtonComponent>
    );
  }
);

export default IconButton;
